const join = require('./join');
const split = require('./split');

/**
 * Normalise a path's syntax to use the expected normal syntax
 * @param {LeafPath} path The path to normalise
 * @returns {LeafPath} The normalised path
 * @example
 * normalise('foo["bar"].baz');
 * // => 'foo.bar.baz'
 */
function normalise(path) {
  return join(split(path));
}

module.exports = normalise;
